var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-btn',_vm._b({on:{"click":function($event){return _vm.$store.dispatch('auth/logOut', _vm.axios)}}},'base-btn',_vm.$attrs,false),[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-logout")]),_c('span',[_vm._v("Logi välja")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }